import React from 'react';

import {
  AvatarContainer,
  ContentContainer,
  TypographyH5,
  TypographyBody2,
} from './Style.js';

import Hourglass from 'assets/svg/hourglass-illustration.svg';
import MagnifyIllustration from 'assets/svg/magnifying-glass-illustration.svg';
import Avatar from 'Components/Avatar';


/**
 * Booking Form Component
 * @param {Object} props
 * @param {Object} props.appointment
 * @param {String} props.header
 * @param {String} props.body
 * @param {String} props.displayName
 * @return {ReactElement}
 */
export default function MessageDisplay(props) {
  const {
    appointment,
    body,
    displayName,
    header,
    isCancelled,
    isCciAccount,
    isExpired,
  } = props;

  const style = {
    height: '2rem',
    width: '2rem',
    borderRadius: '10px',
    fontSize: '1rem',
    lineHeight: '2rem',
  };

  return (
    <>
      {
        appointment && !isCciAccount &&
        <AvatarContainer>
          <Avatar
            displayName={displayName}
            boxStyle={{}}
            nameStyle={{}}
            avatarStyle={style}
          />
        </AvatarContainer>
      }
      <ContentContainer>
        {
          isExpired &&
          <img height="120" width="120" src={Hourglass} alt="hourglass"/>
        }
        {
          isCancelled &&
          <img height="120" width="120" src={MagnifyIllustration} alt="magnifying-glass"/>
        }
        <TypographyH5>
          <b>{header}</b>
        </TypographyH5>
        <TypographyBody2>
          {body}
        </TypographyBody2>
      </ContentContainer>
    </>
  );
}
